var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 text-gray-500"},[_vm._v(" "+_vm._s(_vm.message.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }